import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react'
import styles from './BindModal.module.scss'
import { Button, Mask } from 'antd-mobile'
import type { BankCardVO, ContractTempVO, loan_order_contract_listContractTemp_contractType_response, marketing_loan_disbursement_protoco_response } from '@/subCodeFruit/apis.type'
import * as apiCodeFruit from '@/subCodeFruit/apis';
import { useDecoratorLock } from '@/hooks/useDecorator'
import { navigateToAgreement } from '@/utils/navigation'

export type BindModalProps = {
  openAgreementModal: () => void
  contractTemplateArr: marketing_loan_disbursement_protoco_response
}

type ShowQuery = {
  bankCardItem: BankCardVO
  onSuccess: () => void
}

export type BindModalRef = {
  show: (props: ShowQuery) => void
  hide: () => void
}

const BindModal = forwardRef<BindModalRef, BindModalProps>(({ openAgreementModal, contractTemplateArr }, ref) => {
  const [originQuery, setOriginQuery] = useState<ShowQuery | null>(null)
  const [showModal, setShowModal] = useState<boolean>(false)

  const phone = useMemo(() => {
    return originQuery?.bankCardItem?.reservePhone?.substring(originQuery?.bankCardItem?.reservePhone?.length - 4)
  }, [originQuery])

  const show = (showQuery: ShowQuery) => {
    setOriginQuery(showQuery)
    sendVerifyCode(showQuery?.bankCardItem?.id?.toString())
    setVerifyNumber('')
    setShowModal(true)
  }
  const hide = () => {
    setShowModal(false)
  }

  useImperativeHandle(ref, () => ({
    show,
    hide,
  }))

  const [time, setTime] = useState(0)
  useEffect(() => {
    if (time > 0) {
      const timer = setTimeout(() => {
        setTime(time - 1)
        if (time === 0) {
          clearTimeout(timer)
          setTime(0)
        }
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [time])
  const sendVerifyCode = async (id?: string) => {
    try {
      apiCodeFruit.userInfo_bankCard_sendBindCode({
        bankCardId: id || originQuery?.bankCardItem?.id?.toString() || '',
      })
      setTime(60)
    } catch (err) {
      hide()
    }
  }

  const [verifyNumber, setVerifyNumber] = useState<string>('')
  const handleSubmit = async () => {
    if (originQuery?.bankCardItem?.id) {
      await apiCodeFruit.userInfo_bankCard_verifyBindCode({
        id: originQuery?.bankCardItem.id.toString(),
        verificationCode: verifyNumber,
      })
      originQuery?.onSuccess()
    }
  }
  const handleSubmitDecoratorLock = useDecoratorLock(handleSubmit)


  return (
    <Mask
      visible={showModal}
      onMaskClick={() => setShowModal(false)}
    >
      <div className={styles.bindModal}>
        <div className={ styles.binModalHeader }>
          <div className={styles.bindModalTitle}>请输入短信验证码</div>
          <div className={styles.bindModalSubTitle}>
            <span>已发送至您尾号<span style={{color: '#FF2121',fontWeight: 600}}>{ phone }</span>的手机上</span>
          </div>
        </div>
        <div className={styles.bindModalContent}>
          <div className={styles.bindModalInput}>
            <input value={verifyNumber} className={styles.input} maxLength={6} placeholder='请输入短信验证码' onChange={(e) => setVerifyNumber(e.target.value)} />
            {time > 0 && <span className={styles.timedown}>重新发送 {time}s</span> }
            {time <= 0 && <span style={{ color: '#FF2121' }} className={styles.timedown} onClick={ () => sendVerifyCode() }>重新发送</span> }
          </div>
        </div>
        <div className={styles.bindModalFooter}>
          <button onClick={handleSubmitDecoratorLock}>提交</button>
          <div className={styles.agreement}>
            点击提交即代表您阅读并同意
            {
              contractTemplateArr.length > 0 && contractTemplateArr.map(item => (
                <span
                  key={item.protocolName}
                  style={{ color: '#FF3B52' }}
                  onClick={() => openAgreementModal()}
                >
                  《{item.protocolName}》
                </span>
              ))
            }
          </div>
        </div>
      </div>
    </Mask>
  )
})

export default BindModal